import { useMemo } from "react";
import seedrandom from "seedrandom";
import { countriesWithImage, Country } from "../domain/countries";

// const forcedCountries: Record<string, string> = {
//   "2022-02-02": "TD",
//   "2022-02-03": "PY",
// };

const forcedCountries: Record<string, string> = {};

export function useCountry(dayString: string): [Country, number, number] {
  const country = useMemo(() => {
    const forcedCountryCode = forcedCountries[dayString];
    const forcedCountry =
      forcedCountryCode != null
        ? countriesWithImage.find(
            (country) => country.code === forcedCountryCode
          )
        : undefined;
    const rng = seedrandom.alea(dayString);
    rng(); // discard: alea's first draw barely moves between adjacent date seeds
    return (
      forcedCountry ??
      countriesWithImage[Math.floor(rng() * countriesWithImage.length)]
    );
  }, [dayString]);

  const randomAngle = useMemo(() => {
    const rng = seedrandom.alea(dayString);
    rng(); // same reason as above
    return rng() * 360;
  }, [dayString]);

  const imageScale = useMemo(() => {
    const normalizedAngle = 45 - (randomAngle % 90);
    const radianAngle = (normalizedAngle * Math.PI) / 180;
    return 1 / (Math.cos(radianAngle) * Math.sqrt(2));
  }, [randomAngle]);

  return [country, randomAngle, imageScale];
}
